<template>
  <section class="main-container print-bg modal-card-body"
           :class="{isActive: edit, stories: isStory, 'isEng' : $isStories}"
           :id="`post-${post.id}`">
    <div class="post columns section" >
      <div class="column post-content">
        <div v-if="!isStory"
             :class="{bottomheader : !hasAttachments, 'justify-content-center' : edit, 'card-container' : !isActivityFeed}"
             class="is-one-fifth-tablet mb-2">
          <p class="date" v-if="!edit"
             :data-balloon="formatTimestamp(this.post.created)"
             data-balloon-pos="left">{{formattedDate}}</p>
          <button v-if="isTemplatePost && canEdit"
                  @click="showTemplateSettingsModal">Template Section <i class="fas fa-cog"/>
          </button>

          <div class="edit-or-report is-flex">
            <div v-if="!isActivityFeed" class="project-creator is-flex gtm-proj-creator">
              <div v-if="!isStory && showVisibilityButton(post.user.id)" @click="editTeam" tabindex="0" @keypress.enter.space="editTeam" class="primary-hover">
                <i  class="fal fa-plus-circle has-text-primary" aria-hidden="true"></i>
                <span class="subtitle is-7 is-marginless">{{ $t('teamModal.setVisibility') }}</span>
              </div>
              <div v-if="!edit && !saving && isDownloadable" class="is-flex download-container primary-hover" @click="downloadAttachment(post.attachments)">
                <span class="container"><i class="fal fa-download"></i></span>
                <p class="download-title">Download</p>
              </div>
              <div v-if="canEditSubmission && !edit && !isTable()"
                   @click="toggleEdit"
                   class="is-flex primary-hover">
                <span class="container"
                  :class="{isActive: edit}">
                  <i class="fal fa-pencil-alt"/>
                </span>
                <p class="edit-title">Edit Section</p>
              </div>
              <div v-if="!edit && (!canEdit || !isAdmin)" class="is-flex report-flag">
                <report v-if="!isPrivate" :post="post"></report>
              </div>
            </div>
          </div>

          <div v-if="isFeed && post.project" :class="{bottomheader: !hasAttachments}" class="feed-card-container is-one-fifth-tablet">
            <div class="project-image cursor-pointer" @click="openProjectInNewTab(post.project.id)" tabindex="0">
              <img :src="post.project.image">
            </div>
            <div class="post-header">
              <div class="card-container">
                <div class="is-full-width has-text-weight-bold cursor-pointer" @click="openProjectInNewTab(post.project.id)">{{ post.project.title }}</div>
                <div class="is-full-width" v-line-clamp="3">{{ post.project.description }}</div>
                <div class="poster-container is-flex" @click="view(user)">
                  <div class="card-image-container">
                    <figure class="poster-image">
                      <img :src="thumbnail(avatar)" :alt="username">
                    </figure>
                  </div>
                  <p class="poster">{{username}}</p>
                  <div v-if="post.user.isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></div>
                </div>
                <p class="date" v-if="!edit" :data-balloon="formatTimestamp(this.post.created)" data-balloon-pos="left">{{formattedDate}}</p>
              </div>
            </div>
          </div>
        </div>
          <div v-if="edit && post.postFeatures.canEdit || edit && isAdmin">
            <create-inline ref="reply"
                           :post="post" :update="edit" :context="'inline'"
                           :carouselPosition="carouselPosition"
                           @saveAndClose="saveAndClose"
                           @saved="toggleEdit" @saving="saving = $event"
                           @annotateOriginal="annotateOriginal" @cancel="toggleEdit('cancel')"
            ></create-inline>
          </div>
          <div v-else :class="{recommendation: isRecommendation, 'hide-text': post.body === '', 'post-wrapper': needPostWrapper}">
            <carousel v-if="hasAttachments" v-bind="{attachments, canCreate, isGrid, canEdit, project, post}"
                      @position="updateCarouselPosition"
                      :initialPosition="carouselPosition"
                      @annotate="makeAnnotation"
                      :activeTab="stateActiveTab"
                      @edit="editAttachment"
                      @deleting="showDeleteAttachmentModal = true"
                      :getPostDirection="getPostDirection" />
        <div v-if="isPaywall && !isOnlyForLoggedInUser && isDisabled" class="paid-modals">
              <h4 class="is-size-4 has-text-left pb-2">Hi{{ currentUser.fullName !== undefined ? ', ' + currentUser.fullName : '' }}</h4>
              <p class="has-text-left pb-5">You have exhausted your limit of 5 free articles. To continue reading:</p>
              <div class="cta-container">
                <sponsored-button type="cta-button" class="gtm-footer-personalize-feed">Subscribe Now!</sponsored-button>
              </div>
            </div>
            <div v-else-if="isOnlyForLoggedInUser" class="paid-modals">
              <span style="display: flex; align-items: center;"><img class="lock-size-reduce" src="/static/keys/lock_yellow.png"> <p class="login-text">   This resource is available for free to engineering.com members. Please login or create an account.</p></span>
              <div class="login-container">
                <sponsored-button type="cta-button" @click="showLoginModal" class="gtm-footer-personalize-feed">Login</sponsored-button>
                <button class="button cancel-button" @click="goBack()">Back</button>
              </div>
            </div>
        <div v-if="this.showArticleModal">
          <resource @hook:mounted="openWhenLoggedIn" @modalDone="articleModalDone" :project="this.project" class="confirm-visibility" ref="articleModal"></resource>
        </div>
        <p class="post-text" :class="[{storyFont: isStory, 'is-paywall': showPayWallBlur }]" v-if="post.body && post.body.length">
          <html-view ref="htmlView" :content="post.body" :adHeights="adHeights" :isEngArticle="isEngArticle" @adZonePositions="adZonePositions"></html-view>
        </p>
      </div>
      <div v-if="!edit && showStatusButtons">
        <div class="post-status-message-container">
          <i class="fa-solid mx-1 status-icon" :class="postStatusIcon"></i>
          <p class="post-status-text">{{ postStatusText }}</p>
        </div>
        <div class="post-status-container">
          <button v-if="canUpdateReviewStatus && !isStatusReadyForReview && !isStatusCompleted" @click="openStatusReviewModal" class="post-status-button review-button">READY FOR REVIEW</button>
          <button v-if="canUpdateCompletedAndDraftStatus && (isStatusReadyForReview || isStatusCompleted)" @click="openStatusDraftModal" class="post-status-button draft-button">BACK TO DRAFT</button>
          <button v-if="canUpdateCompletedAndDraftStatus && !isStatusCompleted" @click="openStatusCompleteModal" class="post-status-button completed-button">COMPLETED</button>
        </div>
      </div>
      <div v-if="!isRecommendation && !isStory && !edit && !isRegistrationFormProject"
           class="like is-flex bottom-container no-print"
           :class="{'borderBottom' : edit && commentLength}"
           ref="bottomContainer">
        <div class="is-flex bottom-buttons no-print">
          <div class="left-buttons is-flex">
            <span class=" thumb-post primary-hover cursor-pointer is-flex"
                  :class="{[uniqueClass]: true}"
                  tabindex="0"
                  @click="like"
                  @keypress.space.enter="like"
                  @mouseenter="showLikes"
                  @mouseleave="hideLikes">
              <span class="dropper"
                    v-if="dropdowns.likes.show && !isTouch && post.metadata.likes > 0">
                <drop-down :users="dropdowns.likes.users"
                           :loading="dropdowns.likes.loading"
                           @fetch="fetchLikedBy"
                           @close="hideLikes"
                           @click="toggleLikes" />
              </span>
              <i :class="{'has-text-primary far': hasLiked || this.submitLike, 'fal': !hasLiked || !this.submitLike}"
                 class="fa-thumbs-up" />
              <template v-if="post.metadata.likes">
                <span class="number-meta">{{post.metadata.likes}}</span>
              </template>
              <p v-if="post.metadata.likes > 0">{{this.likeTitle}}</p>
            </span>

                <span  v-if="showShareButton"
                       tabindex="0"
                       @keypress.enter.space="showShareButton"
                       class="share">
              <share-menu class="share-btn"
                          :project="project"
                          :post="post"
                          :newIcon="true"
                          :isPrivate="this.isPrivate"
                          :isPostPrivate="this.isPostPrivate"
                          :isCreatorMenu="false" />
            </span>
              </div>
              <div class="right-buttons is-flex">
                <div class="replies is-flex">
                  <p class="number-meta">{{post.metadata.comments}}</p>
                  <p>{{this.replyTitle}}</p>
                </div>
                <div v-if="!gridModalOpen && post.metadata.comments > 2" @click="viewAllReplies()" class="all-replies is-flex primary-hover">
                  <p>{{$t('projectPage.viewAllReplies')}}</p>
                </div>

              </div>
            </div>
          </div>
          <div v-if="isStory" class="is-flex" :class="{like: edit}" >
            <span class="cancel" v-if="edit && !saving" @click="showEditModal = true">{{ $t('cancel') }}</span>
          </div>
          <div v-if="isStory && hasSponsorButton" class="sponsor-button-container">
            <sponsored-button type="cta-button" @click="openURL(sponsorButton.link)">{{ sponsorButton.name }}</sponsored-button>
          </div>
          <span v-if="isEngAd">
        <!-- neweng ad box #1 -->
        <div ref="adOne"  class="adscontainer-one is-flex" :class="{static: !adPositions.adOneOffsetTop}" :style="{ '--position-top-mobile': `${adPositions.adOneOffsetTop}px`}">
          <doubleclickad path="/14357335/EngCom_new_BigBox1" :size="[[300, 600], [300, 250]]" :primaryCategory="project.primaryCategoryID" :articleType="articleType" :articleID="articleID" :key="articleID"></doubleclickad>
        </div>
            <!-- neweng ad box #2 -->
        <div ref="adTwo" class="adscontainer-two is-flex" :class="{static: !adPositions.adTwoOffsetTop}" :style="{ '--position-top': `${adHeights[0]}px`, '--position-top-mobile': `${adPositions.adTwoOffsetTop}px`}">
          <doubleclickad path="/14357335/EngCom_new_BigBox2" :size="[[300, 600], [300, 250]]" :primaryCategory="project.primaryCategoryID" :articleType="articleType" :articleID="articleID" :key="articleID"></doubleclickad>
        </div>
            <!-- neweng ad box #3 -->
        <div ref="adThree" class="adscontainer-three is-flex" :class="{'hide': adPositions.adTwoOffsetTop === 0}">
          <doubleclickad path="/14357335/EngCom_new_BigBox3" :size="[[300, 600], [300, 250]]" :primaryCategory="project.primaryCategoryID" :articleType="articleType" :articleID="articleID" :key="articleID"></doubleclickad>
        </div>
      </span>
      <comments @showPostGrid="viewAllReplies" v-if="!isRecommendation && !fromStartButton && !isRegistrationFormProject" class="comments-loaded" ref="comments"
      v-bind="{edit, post, contribute}" :isGrid="isGrid" :gridRef="gridRef" :isFeed="isFeed" @reply="showCreateComment" @created="contribute = 0" @cancel="contribute = 0" @like="like" :selectedCommentID="selectedCommentID">
      </comments>
      <div ref="commentsContainer"></div>
    </div>
    <modal-custom
      v-if="showCannotDeleteModal"
      :hasFooter="true"
      :title="$t('projectPage.unableDeleteSection')" :text="$t('projectPage.atLeastOneSection')"
      :successText="$t('ok')"
      @modalSuccess="showCannotDeleteModal = false"
    ></modal-custom>
    <modal-custom
      v-if="showDeleteModal"
      :hasFooter="true"
      :title="$t('projectPage.confirmDeleteSection')" :text="$t('projectPage.deleteSection')"
      :successText="$t('projectPage.yesDelete')" :cancelText="$t('cancel')"
      @modalSuccess="deletePost" @modalCancel="showDeleteModal = false"
    ></modal-custom>
    <modal-custom
      v-if="showEditModal"
      :hasFooter="true"
      :title="$t('projectPage.confirmCancel')" :text="$t('projectPage.confirmCancelSection')"
      :successText="$t('yes')" :cancelText="$t('no')"
      @modalSuccess="cancelEdit" @modalCancel="showEditModal = false"
    ></modal-custom>
    <modal-custom
      v-if="showDeleteAttachmentModal"
      :hasFooter="true"
      :title="$t('projectPage.confirmDeleteAttachment')" :text="$t('projectPage.deleteAttachment')"
      :successText="$t('projectPage.yesDelete')" :cancelText="$t('cancel')"
      @modalSuccess="deleteAttachment" @modalCancel="showDeleteAttachmentModal = false"
    ></modal-custom>
    <modal-progress ref="downloadProgress"></modal-progress>
    <modal-custom
      v-if="showTemplateWarningModal"
      :hasFooter="true"
      :title="'Warning Post Template'" :text="'You are about to edit a post from a Project Template.'"
      :cancelText="$t('OK')"
      @modalCancel="showTemplateWarningModal = false"
    ></modal-custom>
    <modal-custom
        v-if="showStatusReviewModal"
        :hasFooter="true"
        :title="$t('This Section is Ready for Review')" :text="$t('projectPage.reviewConfirmation')"
        :successText="$t('OK')"
        :cancelText="$t('Cancel')"
        @modalSuccess="markStatusChange('ReadyForReview')"
        @modalCancel="showStatusReviewModal = false"
    ></modal-custom>
    <modal-custom
        v-if="showStatusCompleteModal"
        :hasFooter="true"
        :title="$t('This Section is Complete')" :text="$t('projectPage.completeConfirmation')"
        :successText="$t('OK')"
        :cancelText="$t('Cancel')"
        @modalSuccess="markStatusChange('Completed')"
        @modalCancel="showStatusCompleteModal = false"
    ></modal-custom>
    <modal-custom
        v-if="showStatusDraftModal"
        :hasFooter="true"
        :title="$t('Return This Section to Draft')" :text="$t('projectPage.draftConfirmation')"
        :successText="$t('OK')"
        :cancelText="$t('Cancel')"
        @modalSuccess="markStatusChange('Draft')"
        @modalCancel="showStatusDraftModal = false"
    ></modal-custom>
    <post-template-modal v-if="!$isEngCom" :post="this.post" ref="postTemplateModal"></post-template-modal>
      <edit-private-section-modal ref="editPrivateSectionModal" v-bind="{loading, hasMore, addCallback, removeCallback, updateCallback, addPostCallback, removePostCallback, updatePostCallback, members, postMembers, post}" @close="$emit('close')" @fetchPostMembers="fetchPostMembers" @getMembersCount="getMembersCount"></edit-private-section-modal >
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import lineClamp from 'vue-line-clamp'
import throttle from 'lodash/throttle'
import moment from 'moment'
import breakpoints from '@/libs/breakpoints'
import Comments from './Comments'
import ShareMenu from '../ShareDropdown'
import HtmlView from '@/components/Controls/HTMLView'
import Report from '@/components/UIReport'
import Carousel from '@/components/Forms/AttachmentsCarousel'
import CreateInline from '@/components/Forms/Create/Post'
import ModalCustom from '@/components/Modals/Custom'
import DropDown from '@/components/Controls/MetaCountsDropdown'
import dropDownMixin from '@/components/Controls/MetaCountsDropdown/mixin'
import Doubleclickad from '@/components/Modals/DoubleClickAd'
import ModalProgress from '@/components/Modals/Progress'
import SponsoredButton from '@/components/Controls/ButtonTemplate'
import socket from '@/libs/socket'
import imageProxy from '@/libs/image-proxy'
import userAgent from '@/libs/user-agent'
import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import scrollLock from '@/mixins/scroll-lock'
import downloadAttachment from '@/mixins/download-attachment'
import PostTemplateModal from '@/components/Modals/PostTemplateSettings'
import state from '../state'
import Resource from '@/components/Modals/Resource'

import ProjectTags from '../Header/ProjectTags'
import ProjectCategories from '../Header/ProjectCategories'
import i18n from '@/i18n'

import displayTypes from '@/mixins/project-display-types'
import Team from '../Header/Teams'
import EditPrivateSectionModal from '../Header/Teams/EditPrivateSectionModal'
import userTypes from '@/mixins/user-types'
import postStatusTypes from '@/mixins/post-status-types'

const placeholder = 'Start typing'
const ads = ['adOne', 'adTwo']
const adMargin = 20

Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})

export default {
  props: ['post', 'isGrid', 'gridRef', 'isFeed', 'selectedCommentID', 'getPostDirection'],
  components: {
    HtmlView,
    Carousel,
    Doubleclickad,
    Comments,
    ModalCustom,
    ModalProgress,
    CreateInline,
    ShareMenu,
    Report,
    DropDown,
    breakpoints,
    ProjectTags,
    ProjectCategories,
    SponsoredButton,
    PostTemplateModal,
    Resource,
    Team,
    EditPrivateSectionModal
  },
  mixins: [auth, componentState, dropDownMixin, scrollLock, displayTypes, downloadAttachment, userTypes, postStatusTypes],
  data: function () {
    return {
      submitLike: false,
      text: '',
      placeholder,
      contribute: 0,
      edit: false,
      saving: false,
      showDeleteModal: false,
      showCannotDeleteModal: false,
      showEditModal: false,
      carouselPosition: 0,
      dropdowns: {
        likes: dropDownMixin.initDropdown()
      },
      fetchLimit: 10,
      canCreate: false,
      showDeleteAttachmentModal: false,
      adHeights: [],
      adPositions: {
        adOneOffsetTop: 0,
        adTwoOffsetTop: 0
      },
      showTemplateWarningModal: false,
      teamToolTip: 'Edit Team',
      renderOwners: false,
      postMembers: [],
      postmembersCount: 0,
      membersCount: 0,
      fetchID: 0,
      limit: 20,
      countLimit: 500,
      offset: 0,
      hasMore: false,
      loading: false,
      isShowingArticleModal: false,
      signupForArticleModal: true,
      showStatusReviewModal: false,
      showStatusCompleteModal: false,
      showStatusDraftModal: false,
      jacMemberDistrict: 0,
      studentJacDistrict: 0,
      sameDistrict: false,
      postStatus: ''
    }
  },
  watch: {
    value: function (newValue) {
      if (this.text !== newValue) {
        this.text = newValue
      }
    },
    editState: function (edit) {
      if (edit) {
        this._set(state.posts.edit, false)
        this.edit = true
      }
    },
    hasLiked: function (newHasLiked) {
      this.submitLike = newHasLiked
    }
  },
  computed: {
    members: function () {
      if (!this.isStory) {
        if (this.post.isPrivate && this.$store.getters.allPostmembership(this.post.id) && this._get('isSameAsProject')) {
          return Object.values(this.$store.getters.allPostmembership(this.post.id))
        } else {
          return Object.values(this.$store.state.project.projectMembers[this.post.projectID] ?? [])
        }
      }
    },
    showStatusButtons: function () {
      return (this.isProjectEditable || this.isAdmin) && this.$isOhioScience && this.hasMilestone && this.isMilestoneUser
    },
    hasMilestone: function () {
      return this.post.postFeatures ? this.post.postFeatures.hasMilestone : false
    },
    isMilestoneUser: function () {
      return this.projectRole === 'owner' || this.projectRole === 'co-owner' || this.projectRole === 'contributor' || this.isMilestoneAdminUser
    },
    isMilestoneAdminUser: function () {
      return this.isAdmin || ['admin', 'anonAdmin', 'anonCoordinator'].includes(this.projectRole) || (this.currentUser.type === this.UserTypeMentor && this.projectRole === 'admin') || this.currentUser.type === this.UserTypeJacAdmin
    },
    canUpdateReviewStatus: function () {
      return this.projectRole === 'owner' || this.projectRole === 'co-owner' || this.projectRole === 'contributor' || this.isMilestoneAdminUser
    },
    canUpdateCompletedAndDraftStatus: function () {
      return this.isMilestoneAdminUser
    },
    canStudentEditSection: function () {
      return this.isStatusDraft
    },
    isStatusReadyForReview: function () {
      return this.postStatus === 'ReadyForReview'
    },
    isStatusCompleted: function () {
      return this.postStatus === 'Completed'
    },
    isActivityFeed: function () {
      return this.$route.path.substring(1) === 'feed'
    },
    isStatusDraft: function () {
      return this.postStatus === 'Draft'
    },
    postStatusText: function () {
      if (this.isStatusReadyForReview) {
        return 'READY FOR REVIEW'
      } else if (this.isStatusCompleted) {
        return 'COMPLETED'
      } else {
        return 'DRAFT'
      }
    },
    postStatusIcon: function () {
      if (this.isStatusReadyForReview) {
        return 'fa-pen review-color'
      } else if (this.isStatusCompleted) {
        return 'fa-circle-check completed-color'
      } else {
        return 'fa-note-sticky'
      }
    },
    isProjectSubmitted: function () {
      return this.project.submitted
    },
    isDisabled: function () {
      return false
    },
    isProjectEditable: function () {
      return this.project.isEditable
    },
    isOnlyForLoggedInUser: function () {
      return this.project.isLocked && this.$isStories && !this.isLoggedIn
    },
    canEditSubmission: function () {
      return this.isAdmin || this.projectRole === 'anonAdmin' || this.projectRole === 'anonCoordinator' || (this.isProjectEditable && this.canEdit && this.post?.postFeatures.canEdit && this.canStudentEditSection)
    },
    projectRole: function () {
      return this._get(state.project.role, 'none')
    },
    canDeleteSubmission: function () {
      return this.isAdmin || this.projectRole === 'anonAdmin' || this.projectRole === 'anonCoordinator' || (this.isProjectEditable && this.canEdit && this.post?.postFeatures.canDelete)
    },
    isStory: function () {
      return this.$route.name === 'viewStory'
    },
    isPaywall: function () {
      return this._get(state.paywall)
    },
    fromStartButton: function () {
      return this.$route.params.startButton
    },
    isTouch: function () {
      return userAgent.isIOS() || userAgent.isAndroid()
    },
    isWidescreenAndUp: function () {
      return breakpoints.isWidescreenAndUp()
    },
    commentLength: function () {
      return this.$refs.comments.comments.length > 0
    },
    hasAttachments: function () {
      return this.post.attachments.length > 0
    },
    isDownloadable: function () {
      return this.hasAttachments && this.post.attachments[this.carouselPosition].metadata?.isDownloadable
    },
    isLongPost: function () {
      return (this.post.body.length > 74)
    },
    numberOfPosts: function () {
      return this._get(state.posts.total, false)
    },
    formattedDate: function () {
      if (this.isRecommendation) {
        return 'Recommended'
      }

      let date = moment(this.post.created)
      // no future comments
      if (date.isAfter(moment())) {
        date = moment()
      }
      if (date.isBefore(moment().subtract(2, 'days'))) {
        return date.format('MMM D, YYYY')
      } else {
        return date.fromNow()
      }
    },
    attachments: function () {
      return this.post.attachments
    },
    likeParams: function () {
      return { post: this.post, username: this.currentUser.userName }
    },
    hasLiked: function () {
      return this.isLoggedIn ? this.$store.getters.likedPost(this.post.id, this.currentUser.userName) : false
    },
    canEdit: function () {
      let isPostEditable = false
      const currentRole = this._get(state.project.role, 'none').toLowerCase()
      if (currentRole.indexOf('contributor') !== -1) {
        if (this.currentUser.uuid === this.post.user.uuid) {
          isPostEditable = true
        }
      }
      const editPermission = this._get(state.posts.permissions.edit, false)
      return editPermission || isPostEditable
    },
    isTemplatePost: function () {
      return this.project.isTemplate
    },
    user: function () {
      return this.post ? this.post.user || {} : {}
    },
    avatar: function () {
      return this.user.avatar || '/static/ghost.svg'
    },
    username: function () {
      return this.user.userName || 'Anonymous'
    },
    isRecommendation: function () {
      return this.post && this.post.recommended
    },
    editState: function () {
      return this._get(state.posts.edit, false)
    },
    project: function () {
      return this._get(state.project.id) ? this.$store.getters.project(this._get(state.project.id)) || {} : {}
    },
    isPrivate: function () {
      return this.project ? this.project.isPrivate : false
    },
    isPostPrivate: function () {
      return this.post.project ? this.post.project.isPrivate : false
    },
    needPostWrapper: function () {
      if (!this.isGrid || !userAgent.isIOS()) {
        return false
      }

      // do not apply wrapper if preview is visible
      return !this._get('carouselPreview', false)
    },
    uniqueClass: function () {
      return `like-button-${this._uid}`
    },
    targetPostID: function () {
      return this.$route.query.postID
    },
    stateActiveTab: function () {
      return state.activeTab
    },
    hasSponsorButton: function () {
      return this.project && this.project.article && this.project.article.sponsoredLink !== '' && this.project.article.sponsoredButtonName !== ''
    },
    sponsorButton: function () {
      return {
        link: this.project?.article?.sponsoredLink ?? '',
        name: this.project?.article?.sponsoredButtonName ?? ''
      }
    },
    hasResource: function () {
      return this.project.resource.id !== 0
    },
    resourceType: function () {
      return this.project.resource.type
    },
    gridModalOpen: function () {
      return this._get(state.grid.modalVisible)
    },
    likeTitle: function () {
      return this.post.metadata.likes === 1 ? i18n.t('projectPage.like') : i18n.t('projectPage.likes')
    },
    replyTitle: function () {
      return this.post.metadata.comments === 1 ? i18n.t('projectPage.reply') : i18n.t('projectPage.replies')
    },
    articleType: function () {
      return this.project?.article?.type || ''
    },
    articleID: function () {
      return this.project?.article?.id || 0
    },
    isEngArticle: function () {
      return this.articleID > 0
    },
    isEngAd: function () {
      return this.$isEngCom && this.$route.name !== 'viewProject' && !this.hasResource
    },
    showShareButton: function () {
      return !this.isPrivate || this.isAdmin || this.projectRole === 'contributor'
    },
    isRegistrationFormProject: function () {
      return this.project.displayType === this.DisplayTypeRegistrationForm
    },
    showPayWallBlur: function () {
      return this.isPaywall || this.isShowingArticleModal
    },
    isSignupComplete: function () {
      return this.$store.getters.isSignupComplete
    },
    isSigningUp: function () {
      return this.$store.getters.isSigningUp
    },
    showArticleModal: function () {
      if (this.isEngArticle && this.project.isGated && this.project.isLocked) {
        if (this.isSignupComplete) {
          return true
        } else if (this.isLoggedIn && !this.isSigningUp) {
          return true
        } else {
          return false
        }
      }
    }
  },
  mounted: function () {
    if (this.isLoggedIn) {
      this.$store.dispatch('likedPost', { id: this.post.id, username: this.currentUser.userName })
      this.submitLike = this.hasLiked
    }
    if (this._get(this.createKey())) {
      this.contribute++
    } else if (this._get(this.updateKey())) {
      this.edit = true
    }
    if (this.fromStartButton && this.$store.state.post.posts[this.post.id].saved) {
      this.edit = false
    } else if (this.fromStartButton) {
      this.edit = true
    }
    this.configureLikeToolTip()

    this.$nextTick(() => {
      if (this.targetPostID) {
        if (this.targetCommentID) {
          this._set(state.comments.scrollTo(this.targetPostID), parseInt(this.targetCommentID))
        }
      }
    })
    if (!this.isStory) {
      this.fetchMembership()
      this.fetchPostMembership()
      this.fetchPostMembers(true)
    }
    this.observeAdHeights()
    this.observeAdBoxVisibility()
    this.setPostStatus()
    if (this.project && this.project.id && (this.project.primaryCategoryID === 0 || !this.project.primaryCategoryID)) {
      const params = {
        id: this.project.id,
        force: true
      }
      this.$store.dispatch('getProject', params)
    }
  },
  methods: {
    fetchPostMembers: function (reset = false) {
      if (!this.post || !this.post.id) {
        return
      }
      if (reset && this.fetchID === this.post.id) {
        return true
      }
      this.fetchID = this.post.id
      if (reset === true) {
        this.postMembers = []
        this.offset = 0
        this.hasMore = false
      } else {
        this.offset += this.limit
      }
      this.loading = true
      this.$store.dispatch('getPostMembers', { post: this.post, limit: this.limit, offset: this.offset }).then((response) => {
        this.postMembers.push.apply(this.postMembers, response.postMember)
        this.hasMore = response.hasMore

        if (this.currentUser !== this.post.user.userName) {
          this.postMembers.forEach((m, i) => {
            if (m.user.id === this.currentUser.id) {
              var temppostMember = this.postMembers[0]
              this.postMembers[0] = this.postMembers[i]
              this.postMembers[i] = temppostMember
            }
          })
        }
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    getMembersCount: function () {
      this.$store.dispatch('getMembersCount', { project: this.project, limit: this.countLimit, offset: 0 }).then((response) => {
        this.membersCount = response.all
      })
    },
    getPostMembersCount: function () {
      this.$store.dispatch('getPostMembersCount', { post: this.post, limit: this.countLimit, offset: 0 }).then((response) => {
        this.postmembersCount = response.all
      })
    },
    addCallback: function (member) {
      if (this.members.filter((m) => { return m.user.uuid === member.user.uuid }).length === 0) {
        this.members.push(member)
      }
    },
    addPostCallback: function (postmember) {
      if (this.postMembers.filter((m) => { return m.user.uuid === postmember.user.uuid }).length === 0) {
        this.postMembers.push(postmember)
      }
    },
    updateCallback: function (member) {
      this.members.forEach((m, i) => {
        if (m.user.uuid === member.user.uuid) {
          this.$set(this.members, i, member)
        }
      })
    },
    updatePostCallback: function (postmember) {
      this.postMembers.forEach((m, i) => {
        if (m.user.uuid === postmember.user.uuid) {
          this.$set(this.postMembers, i, postmember)
        }
      })
    },
    removeCallback: function (member) {
      this.members = this.members.filter((m) => {
        return m.user.uuid !== member.user.uuid
      })
    },
    removePostCallback: function (postmember) {
      this.postMembers = this.postMembers.filter((m) => {
        return m.user.uuid !== postmember.user.uuid
      })
    },
    setPostStatus: function () {
      const postStatus = this.checkPostStatus(this.post)
      switch (postStatus) {
        case 'ReadyForReview':
          this.postStatus = 'ReadyForReview'
          break
        case 'Completed':
          this.postStatus = 'Completed'
          break
        default:
          this.postStatus = 'Draft'
      }
    },
    openStatusReviewModal: function () {
      this.showStatusReviewModal = true
    },
    openStatusCompleteModal: function () {
      this.showStatusCompleteModal = true
    },
    openStatusDraftModal: function () {
      this.showStatusDraftModal = true
    },
    goBack: function () {
      if (window.history.length < 2) {
        this.$router.push({ name: 'home' })
      } else {
        this.$router.go(-1)
      }
    },
    openResourceModal: function () {
      if (!this.isLoggedIn) {
        this.$store.dispatch('resourceButtonClicked', true)
        this.$store.dispatch('showLoginModal', { source: 'resourcePage:' + this.project.id })
      } else {
        this.$refs.articleModal.showModal()
      }
    },
    openWhenLoggedIn: async function () {
      if (this.isLoggedIn && !this.$refs.articleModal.active) {
        await this.$refs.articleModal.fetchQuestions()
        this.isShowingArticleModal = true
        this.$refs.articleModal.showModal()
        this.isLoggingIn = false
        this.$store.dispatch('resourceButtonClicked', false)
      }
    },
    created: function () {
      this._callback('lockScrolling', false)
    },
    destroyed: function () {
      this._callback('unlockScrolling', true)
    },
    observeAdHeights: function () {
      if (!this.isEngAd) {
        return
      }
      const resizeObserver = new ResizeObserver(() => {
        this.getAdHeights()
      })
      ads.forEach(ad => {
        resizeObserver.observe(this.$refs[ad])
      })
    },
    observeAdBoxVisibility: function () {
      if (!this.isEngAd) {
        return
      }
      const observer = new IntersectionObserver((entries, observer) => {
        this.$refs.htmlView.createAdZones()
      })
      ads.forEach(ad => {
        observer.observe(this.$refs[ad])
      })
    },
    getAdHeights: function () {
      ads.forEach((ad, idx) => {
        if (this.$refs[ad] && this.$refs[ad].clientHeight) {
          this.$set(this.adHeights, idx, this.$refs[ad].clientHeight + adMargin)
        }
      })
    },
    adZonePositions: function (adZoneOne = false, adZoneTwo = false) {
      ads.forEach((ad, i) => {
        this.adPositions[`${ad}OffsetTop`] = arguments[i] ? arguments[i].offsetTop + arguments[i].offsetHeight + adMargin / 2 + (this.adHeights?.[i - 1] || 0) : 0
      })
    },
    isTable: function () {
      if (this.$refs.htmlView) {
        return this.$refs.htmlView.getHTML().indexOf('<table') >= 0 && !this.isAdmin
      } else {
        return false
      }
    },
    fetch: function (type, method) {
      const params = { id: this.post.id, limit: this.fetchLimit, offset: this.dropdowns[type].offset }
      return this.fetchDropdown(type, method, params)
    },
    fetchLikedBy: function () {
      return this.fetch('likes', 'postLikedBy')
    },
    showLikes: function () {
      return this.showDropdown('likes')
    },
    hideLikes: function (event) {
      return this.hideDropdown('likes', event)
    },
    toggleLikes: function () {
      return this.toggleDropDown('likes')
    },
    toggleEdit: function (action) {
      if (this.fromStartButton) {
        if (action === 'cancel') {
          this.showEditModal = true
          this.$emit('closeActive')
        } else {
          this.edit = !this.edit
        }
      } else {
        if (this.edit) {
          if (action === 'cancel') {
            this.showEditModal = true
          } else {
            this.saving = false
            this.edit = false
          }
          this.$parent.modalArrow = true
        } else {
          if (this.project.isTemplate) {
            this.showTemplateWarningModal = true
          }
          this.$parent.modalArrow = false
          this.edit = true
        }
      }
    },
    editAttachment: function () {
      this.toggleEdit()
      this.$nextTick(() => {
        this.annotateOriginal()
      })
    },
    annotateOriginal: function () {
      if (this.attachments[this.carouselPosition]) {
        this.$refs.reply.$refs.attachments.editAttachment(this.carouselPosition)
      }
    },
    deleteAttachment: function () {
      this.showDeleteAttachmentModal = false
      this.toggleEdit()
      this.$nextTick(() => {
        if (this.attachments[this.carouselPosition]) {
          this.$refs.reply.$refs.attachments.deleteAttachment(this.carouselPosition)
        }
      })
    },
    updateCarouselPosition: function (position) {
      this.carouselPosition = position
    },
    deletePost: function () {
      const post = this.post
      this.$store.dispatch('deletePost', post).then(() => {
        this._set(state.posts.total, this.numberOfPosts - 1)
      })
      socket.delete('project', post.projectID, 'post', post.id)
      this.$emit('deleteProject')
    },
    cancelEdit: function () {
      this.showEditModal = false
      if (this.fromStartButton || this.fromTemplate) {
        this.$emit('closeActive')
      }
      this.edit = false
      this.$refs.reply.body = this.$refs.reply.post.body
      this._set(this.updateKey(), null)
    },
    showLoginModal: function () {
      return this.$store.dispatch('showLoginModal')
    },
    view: function (user) {
      this.$router.push({ name: 'profile', params: { username: user.userName } })
    },
    viewProject: function (id) {
      this.$router.push(`/project/${id}`)
    },
    openProjectInNewTab: function (id) {
      const routeData = this.$router.resolve(`/project/${id}`)
      window.open(routeData.href, '_blank')
    },
    showCreateComment: function () {
      this.contribute++
      this.$refs.comments.clearReply()
      this.$refs.comments.$refs.add.$refs.createBox.focus()
      this.$nextTick(() => {
        this.$refs.comments.$refs.add.$el.scrollIntoView({ block: 'end', behavior: 'auto' })
      })
    },
    like: throttle(function () {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'postlike:' + this.post.projectID, onSuccess: this.like, signupMessage: 'Sign up to like ' + this.post.user.userName + '\'s post' })
      }
      this.submitLike = !this.hasLiked
      if (this.hasLiked) {
        this.$store.dispatch('unlikePost', this.likeParams).then(() => {
          this.configureLikeToolTip()
          this.resetDropdownUsers('likes')
          return this.fetch('likes', 'postLikedBy')
        })
      } else {
        this.$store.dispatch('likePost', this.likeParams).then(() => {
          this.configureLikeToolTip()
          this.resetDropdownUsers('likes')
          return this.fetch('likes', 'postLikedBy')
        })
      }
    }, 500, { leading: true, trailing: false }),
    createKey: function (isUpdate) {
      return this._uicreateKey(this.post.projectID, null, this.post, isUpdate)
    },
    updateKey: function () {
      return this.createKey(true)
    },
    makeAnnotation: function (type, position) {
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'annotatePost:' + this.post.projectID, onSuccess: this.makeAnnotation, signupMessage: 'Sign up to remix ' + this.post.user.userName + '\'s  whiteboard' })
      }
      const attachment = this.attachments[position]
      if (!attachment) {
        return
      }

      if (type === 'post') {
        this._set(`postFrom.${this.post.projectID}`, attachment)
      } else if (type === 'comment') {
        this._set(`commentFrom.${this.post.id}`, attachment)
      }
    },
    formatTimestamp: function (timestamp) {
      const date = moment(timestamp)
      return date.format('YYYY-MM-DD, HH:mm:ss')
    },
    configureLikeToolTip: function () {
      const likeButton = document.querySelector(`.${this.uniqueClass}`)
      if (likeButton === null) {
        return
      }
      if (this.post.metadata.likes === 0) {
        likeButton.setAttribute('data-balloon', i18n.t('projectPage.like'))
        likeButton.setAttribute('data-balloon-pos', 'up')
      } else {
        likeButton.removeAttribute('data-balloon')
        likeButton.removeAttribute('data-balloon-pos')
      }
    },
    tryDelete: function () {
      if (this.numberOfPosts > 1) {
        this.showDeleteModal = true
      } else {
        this.showCannotDeleteModal = true
      }
    },
    fetchMembership: function () {
      if (!this.isLoggedIn || this.isGrid || this.isFeed) {
        return false
      }
      if (this.post.projectID) {
        this.$store.dispatch('getProject', { id: this.post.projectID, force: false }).then((project) => {
          return this.$store.dispatch('getMembership', { project, user: this.currentUser }).then((membership) => {
            this.canCreate = !!membership
            this._set(state.project.role, membership ? membership.role : 'none')
          })
        })
      }
    },
    fetchPostMembership: function () {
      if (this.post.id) {
        this.$store.dispatch('getPost', { id: this.post.id, force: false }).then((post) => {
          return this.$store.dispatch('getPostMembership', { post, user: this.currentUser }).then((postmembership) => {
            this.canCreate = !!postmembership
          })
        })
      }
    },
    saveAndClose: function (isEdited) {
      if (isEdited) {
        this._set(state.posts.hasModifiedPosts, isEdited)
      }
    },
    thumbnail: imageProxy.thumbnail,
    openURL: function (url) {
      if (url.substring(0, 4) !== 'http' && url.substring(0, 1) !== '/') {
        url = `http://${url}`
      }
      window.open(url, '_blank')
    },
    viewAllReplies: function () {
      this.$emit('showPostGridParent', this.post.id, this.$refs.comments.comments[0].id)
    },
    showTemplateSettingsModal: function () {
      this.$refs.postTemplateModal.active = true
    },
    editTeam: function () {
      this.$refs.editPrivateSectionModal.show(this.post)
    },
    showOwners () {
      this.renderOwners = false
    },
    privateSectionAllowedPartner () {
      if (this.$isOhioScience) {
        return true
      }
    },
    showVisibilityButton: function (userId) {
      if ((this.isAdmin) && this.privateSectionAllowedPartner()) {
        return true
      } else {
        return false
      }
    },
    articleModalDone: function () {
      this.isShowingArticleModal = false
    },
    markStatusChange: function (status) {
      const previousPostStatus = this.postStatus
      this.postStatus = status
      const params = {
        postID: this.post.id,
        projectID: this.post.projectID,
        status: this.postStatus,
        previousPostStatus: previousPostStatus
      }
      this.$store.dispatch('updatePostStatus', params).then(() => {
        this.showStatusReviewModal = false
        this.showStatusCompleteModal = false
        this.showStatusDraftModal = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.post-status-container {
  font-size: 0.85rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 0 2rem 0 2rem;
  @include mobile {
    margin-right: 0.7rem;
  }
}

.post-status-message-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 0.85rem;
  margin: 2rem 2.5rem 0.5rem 0;
}

.status-icon {
  font-size: 1.1rem;
}

.review-color {
  color: orange;
}

.completed-color {
  color: green;
}

.post-status-button {
  padding: 0.5rem 1rem;
  margin: 0 0.25rem;
  background: white;
  border: black 1px solid;
  color: black;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    border: 1px solid transparent;
  }
}

.review-button {
  &:hover {
    background-color: orange;
    color: white;
  }
}

.completed-button {
  &:hover {
    background-color: green;
    color: white;
  }
}

.draft-button {
  &:hover {
    background-color: #595959;
    color: white;
  }
}

.modal-card-body {
  padding: 15px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  overflow: hidden;
}

.is-paywall {
  filter: blur(5px);
  user-select: none;
  pointer-events: none;
}

.paid-modals {
  left: 50%;
  top: 75%;
  max-width: 30rem;
  z-index: 10;
  min-width: 25rem;
  transform: translate(-50%, -75%);
  box-shadow: 0px 0px 20px -1px rgba(0,0,0,0.20);
  position: fixed;
  padding: 35px;
  border-radius: 5px;
  background: var(--background-primary);
}

.post-header {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.edit-label {
  font-size: 0.7rem;
  padding-left: 0.4rem;
}

.post {
  max-width: 100%;
}
.post.section {
  margin: 0;
  padding: 0;
}
template{
  background:#f2f2f2
}
.main-container {
  width: 100%;
  border-top: 2rem solid #f2f2f2;
  @include mobile {
    border-top: 1.5rem solid #f2f2f2;
    &.isActive{
      .like{
        padding-bottom: 1rem;
      }
    }
  }
  &:last-child {
    &.isActive{
      .like{
        padding-bottom: 3rem;
      }
    }
  }
  &:first-child {
    border:none;
  }
}

.stories{
  border-top: 0;
}

.columns:last-child {
  margin-bottom: 0!important;
}

.section{
  padding: 2rem 1.5rem;
  @include mobile {
    margin: 0;
    padding: 0.25rem;
    .column{
      padding-bottom:0.2rem;
    }
  }
}

.card{
  box-shadow:none;
}

.attachments{
  img{
    width:100%;
  }
}
.borderBottom {
  border-bottom: 1rem solid #f2f2f2;
}

.like {
  justify-content: space-between;
  font-size: 0.85rem;
  padding: 1rem 2rem;
  padding-bottom: 0.75rem;
  align-items: center;
  position: relative;

  @include mobile{
    padding: 1rem;
  }
  .far{
    font-size: 0.9rem;
  }
  .active{
    color: $dark;
  }
  .cancel{
    position: absolute;
    right: 14rem;
    @include mobile {
      right: 10rem;
    }
  }
  span{
    line-height: 1rem;
    display: block;
    &:nth-child(1){
      margin-left:0;
    }
    &:nth-child(4){
      position:absolute;
      right:0;
    }
  }
  .dropper {
    position: relative;
    margin-left: 0;
  }
}

.dropdown-menu {
  left: 0;
  bottom: 100%;
}

.comment{
  margin:0.4rem 0;
  background-color:#f5f5f5;
  padding:0.7rem 2rem;
  position:relative;
  font-size:0.9rem;
  .card-container{
    justify-content: space-between;
    display:flex;
    flex-direction: row;
    .comment-date{
      color:#ADAAAA;
    }
  }
  .comment-text{
    padding:0.5rem 0 0 0.5rem;
  }
}

.next{
  margin-left:2rem;
}

.link-box{
  padding: 1rem;
  -webkit-box-shadow: -2px 1px 41px -7px rgba(0,0,0,0.54);
  -moz-box-shadow: -2px 1px 41px -7px rgba(0,0,0,0.54);
  box-shadow: -2px 1px 41px -7px rgba(0,0,0,0.54);
  border-radius:7px;
  h3{
    font-size:2rem;
    display: flex;
    flex-direction:row;
    justify-content: space-between;
    align-items: center;
    @include mobile{
      font-size:1.4rem;
      display:block;
      i{
        font-size: 1rem;
      }
    }
  }
}

.card-container{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  @include mobile {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom:0;
  }
}
.card-container.justify-content-center {
  justify-content: center;
  padding: 1rem;
}

.feed-card-container {
  display:flex;
  align-items: center;
  justify-content: flex-start;
  background-color: white;
  .project-image {
    flex: 1 0 250px
  }
  .card-container {
    display: block;
    padding: 2rem;
  }
  .poster-container {
    margin: 0;
    margin-top: 1rem;
  }
  @include mobile {
    flex-wrap: wrap;
  }
}

.card-content{
  padding:1em;
}

.bottomheader{
  border-bottom: 2px solid #f2f2f2
}

.card-container{
  .card-content{
    @include mobile {
      flex-direction: row;
    }
  }
}
.views{
  color:#ADAAAA;
  font-size:0.9rem;
  text-align: center;
}

.date{
  font-size: 0.8rem;
  color: $grey-light;
  padding-left: 0.8rem;
}

.name{
  font-size: 0.85rem;
}

.media{
  align-items: center;
  .media-left{
    margin-right:0.5rem;
  }
}

.poster-container {
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  margin: 0.75rem 1.5rem;
  @include mobile {
    margin: 0.75rem;
    flex-direction: row;
  }
}

.poster {
  font-size: 1.0rem;
  font-weight: 400;
  padding-left: 0.8rem;
  @include mobile {
    padding-left: 0.5rem;
  }
}

.project-image {
  width: 250px;
  min-width: 250px;
  height: 250px;
  min-height: 250px;
  &:hover {
    cursor: pointer;
  }
  img {
    height: 100%;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    display: block;
  }
}

.poster-image {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  max-width: none;
  user-select: none;
  @include mobile {
    max-height: 2rem;
    max-width: 2rem;
    min-width: 2rem;
  }
  img {
    border-radius: 50%;
    height: 100%;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}

.post-wrapper {
  overflow: auto;
}

.post-text {
  margin: 1rem 0.25rem 0;
  padding: 0 4rem;
  @include mobile {
    padding: 0 0.5rem;
  }
}
.post-text:first-child {
  margin-top: 20px;
}

.storyFont {
  font-family: 'Noto Serif JP', serif;
  font-weight: 500;
  line-height: 1.7;
  padding: 0 3.7rem;
  color: black;
  @include mobile {
    padding: 0 0.7rem;
  }
}

.column.post-content{
  padding: 0;
}
.post-content {
  width: 100%;
  max-width: 100%;
  @include mobile {
    overflow:unset
  }
}

.post {
  .recommendation {
    &.hide-text {
      margin-bottom: -0.9rem;
      .post-text {
        display: none;
      }
    }
  }
}

.isEng{
  background-color: #F8F8F8;
  max-width: 700px; // controls the width of all components
  margin: 0 auto;
}

.primary-hover {
  color: $grey-dark;
  &:hover {
    color: $primary;
  }
}

.adscontainer-one,
.adscontainer-two,
.adscontainer-three {
  justify-content: center;
  align-items: center;
}

.adscontainer-one {
  text-align: center;
  position: fixed;
  z-index: 10;
  top: 200px;
  right: 30px;
  min-width: 300px;
  @media (max-width: 1277px) {
    right: 0;
  }
}
.adscontainer-two {
  position: absolute;
  z-index: 1;
  top: calc(var(--position-top-mobile) - var(--position-top));
  left: 0;
  right: 0;
  &.static {
    position: static;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
@media (max-width: 1200px) {
  .adscontainer-one {
    position: absolute;
    z-index: 1;
    top: var(--position-top-mobile);
    left: 0;
    right: 0;
    &.static {
      position: static;
      margin-top: 20px;
    }
  }
  .adscontainer-two {
    position: absolute;
    z-index: 1;
    top: var(--position-top-mobile);
    left: 0;
    right: 0;
    &.static {
      position: static;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .adscontainer-three {
    &.hide {
      display: none !important;
      border: 1px solid red;
    }
  }
}
.adscontainer-three {
  margin-top: 20px;
  margin-bottom: 20px;
}
.sponsor-button-container {
  display: flex;
  justify-content: center;
  padding: 1rem 0 3rem;
}
.story-edit {
  text-align: right;
  padding-right: 1rem;
}
</style>
<style lang="scss">
@import '~styles/utils.scss';

.post-content {
  .storyFont {
    .htmlview-span-override {
      display: inline-block;
      padding-top: 0.5rem;
      @include mobile {
        padding: 0rem;
      }

      h1, h2, h3, h4{
        font-family: sans-serif !important;
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.edit-or-report {
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  .container {
    margin: 0 0.5rem;
  }
  .delete-container {
    padding-right: 1rem;
  }
  .download-container {
    padding-right: 1rem;
  }
  div {
    cursor: pointer;
  }
  .report-flag {
    padding-left: 1.15rem
  }
}

.bottom-buttons{
  width: 100%;
  border-top: 1px solid #d3d3d3;
  margin-top: 1rem;
  padding-top: 0.75rem;
  justify-content: space-between;
  font-size: 1rem;
}

.thumb-post {
  border-right: 1px solid #d3d3d3;
  padding: 0.25rem 0;
  padding-right: 0.5rem;
  i{
    padding: 0 0.25rem 0 0.20rem;
  }
}

.like span.share {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.25rem;
}
.replies {
  padding-right: 0.25rem;
}

.all-replies {
  border-left: 1px solid #d3d3d3;
  padding-left: 0.25rem;
  cursor: pointer;
}

.number-meta {
  font-weight: bolder;
  padding-right: 0.25rem;
}
.cta-container {
  margin: auto;
  width: 100%;
  padding: 10px;
}
.login-container {
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
}
.cta-button {
  margin-right: 2rem;
}
.remove-margin {
  margin-left: 0;
}
.personalize-button-container {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}
.lock-size-reduce {
  width: 50px;
  height: 50px;
  margin-right: 1rem;
}
.modal-margin {
  padding-top: 18rem;
}
.login-text {
  text-align: center;
}
.cta-container {
  margin: auto;
  width: 50%;
  padding: 10px;
}
.cta-button {
  margin-left: 2rem;
  @include mobile {
    margin-left: 0;
  }
}
.remove-margin {
  margin-left: 0;
}
.personalize-button-container {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}
</style>
